<template>
    <div class="geo-content" :class="bemFacets">
        <div class="grid--row">
            <div class="geo-content--wrapper grid--col">
                <h2 class="geo-content--title u-reset" v-if="title">
                    {{ title }}
                </h2>
            </div>
        </div>
        <div class="grid--row">
            <div class="geo-content--filters grid--col" v-if="isSelectVisible">
                <ui-select :value="currentRegion" @change="updateCurrentRegion">
                    <span slot="label">
                        {{ selectLabel }}
                    </span>
                    <ui-option :value="value" v-for="(label, value) in regions" :key="value">
                        {{ label }}
                    </ui-option>
                </ui-select>
            </div>
        </div>
        <div class="grid--row">
            <div class="geo-content--wrapper grid--col">
                <slot/>
            </div>
        </div>
    </div>
</template>

<script>
    import { bemMixin } from '@dreipol/vue-ui/src/mixins';
    import $ from 'bianco.query';
    import UiSelect from '@dreipol/vue-ui/src/components/form/select/select.vue';
    import UiOption from '@dreipol/vue-ui/src/components/form/option/option.vue';
    import { mapGetters, mapActions } from 'vuex';

    const BLOCK_ACTIVE_CLASS = 'geo-content--region-content__current';

    export default {
        components: {
            UiSelect,
            UiOption,
        },
        mixins: [
            bemMixin('geo-content'),
        ],
        props: {
            isSelectVisible: {
                type: Boolean,
                default: true,
            },
            title: {
                type: String,
                default: '',
            },
            regions: {
                type: Object,
                required: true,
            },
            selectLabel: {
                type: String,
                required: true,
            },
        },
        computed: {
            ...mapGetters('user-region', ['getSafelyUserRegion']),
            currentRegion() {
                return this.getSafelyUserRegion(this.regions);
            },
        },
        methods: {
            ...mapActions('user-region', ['setUserRegion']),
            updateCurrentRegion(event) {
                const { value } = event.target;

                this.setUserRegion({
                    region: value,
                });
            },
            enableRegionalContent() {
                const blocks = $('.geo-content--region-content', this.$el);

                blocks.forEach(block => {
                    const { region } = block.dataset;

                    block.classList[region === this.currentRegion ? 'add' : 'remove'](BLOCK_ACTIVE_CLASS);
                });
            },
        },
        watch: {
            currentRegion() {
                this.enableRegionalContent();
            },
        },
        mounted() {
            this.enableRegionalContent();
        },
    };
</script>
